import script from "./ExamResultQuestionBodyWeb.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamResultQuestionBodyWeb.vue?vue&type=script&setup=true&lang=ts"

import "./ExamResultQuestionBodyWeb.vue?vue&type=style&index=0&id=a97f45f6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a97f45f6"]])

export default __exports__